import { PropsWithChildren } from "react"

type Props = PropsWithChildren & {
  title: string
}

const baseStyle = {
  border: '1px solid #d9d9d9',
  padding: '12px'
}

const PaymentSection = ({title, children}: Props) => {
  return <div>
    <div style={{...baseStyle, borderBottom: 'none', borderRadius: '12px 12px 0 0', backgroundColor: '#fafafa'}}><strong>{title}</strong></div>
    <div style={{...baseStyle, borderRadius: '0 0 12px 12px'}}>{children}</div>
  </div>
}

export default PaymentSection
